import request from '@/utils/request';
// import useFetch from '@/hooks/useFetch';
import { StageEnum } from './home/config';
import {
    GiftInfoValue,
    HomeGiftPackInfoMap,
    RankDataMap
} from './types/gift-pack';
import { ensureResult } from './utils';
// import { addParam } from '@/utils/util';

export interface RankReqItem<T> {
  rankKey: T; // 前端使用，对应的key
  rankListName?: string; // 榜单名称 server
  roleType: 'anchor' | 'user'; // 主播 用户
  limit: number; // 几条数据
  timeType: 'daily' | 'total'; // 日榜 总榜
  targetDate?: string; // 可选，默认当天
  targetUid?: number; // 默认个人信息是自己的，若传此参数就查这个uid的
  groupKeys: string[]; // 分组
}

export interface RankReq<T> {
  params: RankReqItem<T>[];
  activityName?: string;
  shareBucket?: string; // 端外 桶字段
  anchorId:number;
}

export interface ContributeRankType {
  headUrl: string;
  rank: number | string;
  score: number | string;
  userId: number;
  userName: string;
}

export interface MyrankItemType {
  headUrl: string;
  rank: number | string;
  score: number | string;
  userId: number;
  userName: string;
  contributeRankList?: ContributeRankType[]; // 新增主播对应粉丝榜单
  oposerScore?: number;
  winTimes?: number;
}
export interface RankItemType extends MyrankItemType {
  followed: boolean;
  isLiving: boolean;
  isMyself: boolean;
}

export interface RankItemTypeFormat extends RankItemType {
  formatScore?: string | number;
}

export interface itemType {
  privilegeKey: string; // 特权字段 如果为null则查rewardType
  rewardType: string; // 钻石/快点/免费礼物
  rewardCount: number; // 数量

  rewardIcon?: string;
  rewardName?: string;
  rewardUnit?: string; // 'd' '' 展示单位

  // 新版字段与任务奖励字段统一，不需要再从rewardResource中查找奖励图片信息
  type: string;
  picUrl: string;
  name: string;
  unit: number;
}

export interface newItemType {
  // 新版字段与任务奖励字段统一，不需要再从rewardResource中查找奖励图片信息
  type: string;
  picUrl: string;
  name: string;
  unit: number;
}

export interface YesterdayTop1 {
  followed: boolean;
  headUrl: string;
  living: boolean;
  myself: boolean;
  userName: string;
  userId: number;
}

export interface rewardItemType {
  startPosition: number;
  endPosition: number;
  rewards: itemType[];
  newRewards: CommonReward[];
  rewardTexts?: string[];
}

export interface resourceItem {
  icon: string;
  name: string;
}

export interface rewardResourceType {
  [key: string]: resourceItem;
}

export interface CommonReward {
  type?: string;
  rewardType?: string;
  icon?: string;
  subType: string;
  subId: number;
  unit: number;
  bagGiftId: number;
  name: string;
  picUrl?: string;
  bagGiftExpires: number;
  scoreThreshold?: number;
  percentageOfScore?: number;
  percentageOfDiffScore?: number;
  maxUnitCalByScore?: number;
  maxUnitCalByDiffScore?: number;
  calUnitByScore?: boolean;
  addUnitByDiffScore?: boolean;
}

export interface RankRes {
  result: number;
  data: {
    bucket?: string;
    currentUserRank: MyrankItemType; // 根据传入的targetUid确定是主播还是用户的底板信息
    currentAnchorRank: MyrankItemType; // 该字段没有
    eventEndTime: number;
    rankList: RankItemType[];
    totalScore?: number;
  };
  midYearTotalScore: number;
  eventsCode: number;
  reward: rewardItemType[];
  rewardResource?: rewardResourceType;
  yesterdayTop1?: YesterdayTop1;
  groupKey: string;
  rule: string;
}

export type RankResMap<T extends string> = {
  [key in T]: RankRes[];
} & { result: number };

export interface RkRankReq {
  anchorId: number; // 主播id
  targetDate: string; // 第几轮
  groupKey: string; // 分组key
  shareBucket?:string;
}

export interface OpposeItem {
  userInfo: MyrankItemType;
  opposerInfo: MyrankItemType;
}

export interface CurAnchorInfo {
  info: MyrankItemType;
  winTimes: number; // 获胜次数
  rise: boolean; // 是否晋级
  opposerScore: number;
}

export interface PkRankRes {
  result: number;
  totalCountDown: number;
  dailyCountDown: number;
  winnerRewardMap: Record<string, CommonReward[]>;
  opposePairList: OpposeItem[];
  curAnchorInfo: CurAnchorInfo;
  dailyStatus: number;
  finalEnsureScore: number;
}

export interface Meta {
  dayLeft: number;
  bucket: string;
  authorAuth: boolean;
  isLogin: boolean;
  begin: string;
  end: string;
  // h5Config: H5Config; // h5UI配置
  // targetGifts: TargetGift[]; // 活动目标礼物
}

export interface AnchorInfo {
  headurl: string; // 在 dailyGift 接口返回的不是 camelCase
  username: string; //
  headUrl: string;
  userName: string;
  [key: string]: string;
}

export type ConfigType = {
  stage: number; // 当前时间所处的赛段 1. 第1段赛 2.第2赛段 3. 第3赛段.
  anchorRace?: number; // 直播间内, 主播所在的赛道 1. 高收入主播赛道 2.低收入主播赛道
  bucket: string;
  anchorUpgrade?: boolean; // 主播是否晋级
  userUpgrade: boolean; // 当前用户是否晋级
  authority: boolean; // 当前用户是否有主播权限
};

export type RoleType = 'anchor' | 'user';
export type TimeType = 'daily' | 'total';

export interface RelatedRankType {
  rankListName: string;
  timeType: TimeType;
  roleType: RoleType;
  groupMap?: Record<string, string>;
  groupKey: string;
}

export interface RewardItem {
  target: number;
  type: string;
  unit: number;
  name: string;
  picUrl: string;
  subType?: string;
  subId?: number;
}
// export interface PopupItem {
//   title?: string;
//   target?: number;
//   taskType?: string;
//   rewards: RewardItem[];
// }
export interface PopupItem {
  type:string;
  data:Record<string, unknown>;
}
export type Popups = PopupItem[];

export interface TimeInfoItem {
  startTime: string;
  endTime: string;
}
export interface TimeInfoMap {
  ALL: TimeInfoItem;
  PRE: TimeInfoItem;
  OPPOSE: TimeInfoItem;
  FINAL: TimeInfoItem;
}
export interface TimestampInfoItem {
  startTime: number;
  endTime: number;
}
export interface TimestampInfo {
  ALL: TimestampInfoItem;
  PRE: TimestampInfoItem;
  OPPOSE: TimestampInfoItem;
  FINAL: TimestampInfoItem;
}
export interface RelatedRankMapItem {
  groupMap: string;
  period: string;
  rankListName: string;
  roleType: RoleType;
  timeType: TimeType;
}
export interface RelatedRankMap {
  [key: string]: RelatedRankMapItem;
}
export interface GroupInfoMapItem {
  preToOpposeNum: number;
  groupName: string;
  finalToGlobalNum: number;
}
export interface GroupInfoMap {
  [key: string]: GroupInfoMapItem;
}

export interface CountDownMap {
  ALL: number;
  FINAL: number;
  OPPOSE: number;
  PRE: number;
}
export interface GroupPopupItem {
  type: string;
  data: Record<string, unknown>;
}
export interface RankStatusMap {
  ALL: number;
  PRE: number;
  OPPOSE: number;
  FINAL: number;
}
export interface QueryRes {
  'host-name': string;
  bucket: string;
  result: number;
  locateRankName: string;
  timeInfoMap: TimeInfoMap;
  timestampInfoMap: TimestampInfo;
  countDownMap: CountDownMap;
  opposeDayNum: number; // 对抗赛第几天
  // 活动礼物
  giftInfoMap: Record<string, GiftInfoValue>;
  preToOpposeNumMap: {
    // 初赛晋级对抗赛人数
    groupKey: number;
  };
  rankStatusMap: RankStatusMap; // 3种比赛状态 103未开赛
  groupInfoMap: GroupInfoMap;
  relatedRankMap: RelatedRankMap;
  meta: Meta;
  eventsCode: number;
  // author: TaskType;
  // viewer: TaskType;
  anchorInfo: AnchorInfo;
  popups?: Popups;
  festivalConfig?: ConfigType;
  rankListInfo: {
    relatedRankList: RelatedRankType[];
    relatedRankListNames: string[];
    lastDate: string;
    today: string;
  };
  rankGroupKey: string[];
  myRewardEntrance?: Record<string, string | number>;
  visitorInfo: Record<string, string>;

  curUserInfo: AnchorInfo;
  popup: GroupPopupItem[];
  groupKeyList: string[];
  isInAnchorCourse:boolean;
  isCrossBucket:boolean; // 是否跨桶
}

export interface QueryReq {
  anchorId?: number | string;
  missionTag?: string;
  shareBucket?: string;
}

export interface ContributeReq {
  // activityName: string;
  rankListName: string;
  groupKey: string;
  roleType: string;
  timeType?: string;
  targetDate?: string;
  targetUid?: number | string; // 待查询主播id
  limit?: number;
}

export interface ContributeRes {
  result: number;
  rankList: RankItemType[];
  midYearOpposeReward: rewardItemType[];
  rewardList: rewardItemType[];
  anchorInfoMap: {
    anchorRank: number;
    anchorScore: number; // 总积分
    anchorName: string;
    anchorHeadUrl: string;
  };
  midYearAnchorDailyScore: number; // 今日新增积分
}

export interface Res {
  result: number;
}

// 获取pk榜单
export const getPkRankInfo = (params: RkRankReq): Promise<PkRankRes> => {
    return request.get('/rest/o/w/live/midyear/opposeList', { params });
};

// 贡献榜接口
export const getContributeRank = (
    params: ContributeReq
): Promise<ContributeRes> => {
    return request.post('/rest/o/w/live/v2/revenue/activity/contributorRank', {
        data: params,
    });
};

// 获取普通榜单
export const getRankInfo: <T extends string>(
  req: RankReq<T>
) => Promise<RankResMap<T>> = async rankReq => {
    const newParams:any = {
        params: rankReq.params,
        authorId: rankReq.anchorId, // 注意 authorId 和 anchorId
    };
    if (rankReq.shareBucket){
        newParams.shareBucket = rankReq.shareBucket;
    }
    return request.post('/rest/o/w/live/v2/revenue/activity/rank/result', {
        data: newParams,
    });
};

export interface BannerItem {
  titleKey:string;
  jumpUrl:string;
  iconUrl:string;
}

interface TaskHomeRes {
  pkAddition: Record<string, number | string | boolean>;
  taskOrder: (
    | 'cardTask'
    | 'pkTask'
    | 'packGift'
    | 'operation'
    | 'receiveGift'
  )[];
  result: number;
  giftInfoMap: Record<string, GiftInfoValue>;
  giftPackInfo: HomeGiftPackInfoMap;
  timeInfoMap: TimeInfoMap;
  curUserInfo: AnchorInfo;
  today: string;
  bannerList:BannerItem[];
  bucket: string;
}

// query主接口
export const getQueryInfo = (params: QueryReq): Promise<QueryRes> => {
    // const url = addParam('/rest/o/w/live/midyear/home', params);
    // return useFetch(url);
    return request.get('/rest/o/w/live/midyear/home', { params });
};
// 任务主接口
export const getTaskHome = (params: QueryReq): Promise<TaskHomeRes> => {
    return request.get('/rest/o/w/live/midyear/taskHome', { params });
};
// 盛典礼包小时榜接口
export const getGiftPackRank = (params: {
  giftId: number;
  targetDate: string;
  round: number;
}): Promise<{ result: number; rankDataMap: RankDataMap }> => {
    return request.get('/rest/o/w/live/midyear/giftPackRank', { params });
};

export interface ReceiveGiftRes {
  result: number;
  rewards: CommonReward[];
}

// 盛典礼包领取接口
export const receivedGiftPack = (params: {
  giftId: number;
  targetDate: number | string;
  round: number;
  times: number;
}): Promise<ReceiveGiftRes> => {
    return request.get('/rest/o/w/live/midyear/openGiftPack', { params });
};
export type RuleAward = {
  [key: string]: {
    finalEnsureScore: number; // 对抗赛晋级决赛保底分数
    preToOpposeNum: number; // 初赛晋级对抗赛名次
    finalToGlobalNum: number; // 决赛晋级全球赛名次
    totalReward: {
      startPosition: number;
      endPosition: number;
      newRewards: {
        picUrl: string;
        unit: number;
        type: string;
        addUnitByDiffScore: boolean;
        scoreThreshold: number;
        percentageOfDiffScore: number;
        maxUnitCalByDiffScore: number;
      }[];
    }[];
    // 对抗赛 每日奖励 vote
    opposeWinnerReward?: {
      [key: string]: {
        picUrl: string;
        unit: number;
        type: string;
      }[];
    };
    opposeFinalReward: {
      picUrl: string;
      unit: number;
      type: string;
    }[];
  };
};

export type RuleRes = {
  result: number;
  anchorReward: RuleAward;
  userReward: RuleAward;
  timeInfoMap: {
    [key in StageEnum]: {
      startTime: string;
      endTime: string;
    };
  };
  groupKeyList: string[];
  giftInfoMap: {
    [key: string]: {
      name: string;
      picUrl: string;
      unitPrice: string;
    };
  };
  groupNameMap: {
    [key: string]: string;
  };
  online: boolean; // 是否是正赛阶段
};

// 规则接口
export const getRuleInfo = (
    type: StageEnum | 'ALL',
    shareBucket?: string,
    authorId?: string
): Promise<RuleRes> => {
    if (shareBucket) {
        return request.get(
            `/rest/o/w/live/midyear/rule?period=${type}&shareBucket=${shareBucket}`
        );
    }
    if (authorId) {
        return request.get(
            `/rest/o/w/live/midyear/rule?period=${type}&authorId=${authorId}`
        );
    }
    return request.get(`/rest/o/w/live/midyear/rule?period=${type}`);
};

// 浏览任务
export const viewTask = (): Promise<Res> => {
    return request.get('/rest/o/w/live/midyear/preheat/view');
};

export interface IDailyGiftMissionData {
  curAnchorInfo: AnchorInfo;
  dailyCountDown: number;
  userCurrentLevel: number;
  receiveDiamondsCount: number;
  receiveDiamondsTotal: number;
  accumulatedRewardsToday:
    | {
        icon: string;
        name: string;
        unit: number;
        type: string;
      }[]
    | null;
  rewardView: {
    annualGiftList: { icon: string; unit: number }[];
    levels: {
      [key: string]: {
        receiveDiamondsTotal: number;
        rewards: {
          icon: string;
          name: string;
          unit: number;
          type: string;
        }[];
      };
    };
  };
}

// 集卡任务

export type TCardInfo = { reward: number; waiting: number; draw: 0 | 1 };

export interface ICollectMissionData {
  result: number;
  cardInfo: {
    sendGiftThreshold: number;
    pkScoreThreshold: number;
    cardRewardStatus:
      | 'NOT_START'
      | 'CALCULATING'
      | 'REWARDED'
      | 'REWARDING'
      | 'END';
    leftCardShard: number;
    compoundCardNumber: number;
    rewardCountDown: number;
    rewardStartTime: string;
    totalJackpotDiamond: number;
    activityEndTimeCountDown: number;
    compoundCount: number;
    rewardView: {
      [key: string]: {
        icon: string;
        name: string;
        unit: number;
        type: string;
      }[];
    };
    nextRewardView: {
      icon: string;
      name: string;
      unit: number;
      type: string;
    }[];
    cardCollectDetail: {
      FREE: TCardInfo;
      DAILY_GIFT_CARD: TCardInfo;
      SEND_GIFT_CARD: TCardInfo;
      DAILY_PK_CARD: TCardInfo;
      PK_CARD: TCardInfo;
    };
    userCardReward: number; // 开奖结果
  };
  eventsCode: number;
}

export const getCollectMissionData = ensureResult(
    (anchorId?:string, shareBucket?:string): Promise<ICollectMissionData> => {
        let url = `/rest/o/w/live/midyear/getCardInfo?anchorId=${anchorId ?? 0}`;
        if (shareBucket){
            url += `&shareBucket=${shareBucket}`;
        }
        return request.get(url);
    }
);

export const getFreeCard = ensureResult(
    (): Promise<Res & { compoundCard: boolean }> => {
        return request.get('/rest/o/w/live/midyear/freeCard');
    }
);

export interface ICompoundCardRes {
  result: number;
  compoundCardRewards: {
    [key: string]: {
      icon: string;
      name: string;
      unit: number;
      type: string;
    }[];
  };
}

export type packItemType = {
  giftId: number;
  unpackNum: number;
};

export type waitingInfoType = {
  unpackNumMap: {
    [key: string]: {
        unpackNum: number;
        picUrl?: string;
        rewardList: {
            icon: string;
            name: string;
            unit: number;
        }[];
    }
  };
  collect: {
    cardRewardStatus: string;
    compoundCardNumber: number;
    rewardStartTime: number;
  };
};

export type takenItemType = {
  icon: string;
  name: string;
  unit: string;
};

export type detailItemType = {
  time: string;
  bizName: string;
  icon: string;
  name: string;
  unit: number;
};

export type detailListType = {
  [key in string]: detailItemType[];
};

export type MyAnchorInfo = {
  groupName: string;
  rank: number;
  score: number;
  opposeDayNum: number;
  period: string;
};

export type MyUserInfo = {
  score: number;
  rank: number;
  period: string;
  opposeDayNum: number;
};

export type MyInfo = {
  headUrl: string;
  username: string;
};

export interface AwardRes {
  result: number;
  rewards: {
    waitingRewards: waitingInfoType;
    rewardsList: takenItemType[];
    detailList: detailListType;
    anchorInfo: MyAnchorInfo;
    userInfo: MyUserInfo;
    headUrl: string;
    username: string;
  };
}

export interface PopupDetailReq {
  key: string;
}

export interface PopupDetailRes {
  result: number;
  popupDetail: Record<string, any>;
}

export type GiftPackItem = {
  icon: string;
  name: string;
  unit: number;
};

export type GiftPackRes = {
  result: number;
  rewards: GiftPackItem[];
};

export type ScoreItemType = {
  rank: number;
  score: number;
  scoreDetailMap: {
    // source包含以下几种：
    // RECEIVE_GIFT，收礼
    // MID_YEAR_PK_BONUS，PK加成
    // MID_YEAR_GIFT_PACK，盛典礼包
    // MID_YEAR_PREHEAT，预热继承
    // MID_YEAR_MANUAL，后台加分
    // MID_YEAR_GIFT_TASK,主播任务
    // MID_YEAR_COMPOUND_CARD or UNKNOWN卡片合成
    [key: string]: number;
  };
};


export enum ScoreDetailKeys {
    PRE = 'PRE',
    OPPOSE = 'OPPOSE',
    FINAL = 'FINAL',
    ALL = 'ALL'
};

// 票数明细 用户明细
export const ScoreKeysMap = {
    [ScoreDetailKeys.PRE]: 'k_333050',
    [ScoreDetailKeys.OPPOSE]: 'k_333052',
    [ScoreDetailKeys.FINAL]: 'k_333054',
    [ScoreDetailKeys.ALL]: 'k_336607',
};


export type ScoreDetailRes = {
  result: number;
  rankScoreDetail: {
    curPeriod: string;
    groupName: string;
    headUrl: string;
    opposeDayNum: number;
    username: string;
    infoMap: {
      PRE: {
        anchorRankInfo: ScoreItemType;
        userRankInfo: ScoreItemType;
      };
      OPPOSE: {
        anchorRankInfo: ScoreItemType[];
        userRankInfo: ScoreItemType;
      };
      FINAL: {
        anchorRankInfo: ScoreItemType;
        userRankInfo: ScoreItemType;
      };
      ALL: {
        anchorRankInfo: ScoreItemType;
        userRankInfo: ScoreItemType;
      };
    };
  };
};

export type CardJackpotRes = {
    result: number;
    cardJackpot: number;
}

export const compoundCard = ensureResult((): Promise<ICompoundCardRes> => {
    return request.get('/rest/o/w/live/midyear/compoundCard');
});

export const getCardDraw = ensureResult(
    (
        type: keyof ICollectMissionData['cardInfo']['cardCollectDetail']
    ): Promise<Res & { compoundCard: boolean }> => {
        return request.get(`/rest/o/w/live/midyear/cardDraw?taskType=${type}`);
    }
);

export const getCardJackpot = ensureResult((): Promise<CardJackpotRes> => {
    return request.get('/rest/o/w/live/midyear/cardJackpot');
});

// 主播每日任务
export const getDailyGiftMissionData = ensureResult(
    (
        anchorId?: number,
        shareBucket?:string
    ): Promise<
    Res & {
      anchor?: IDailyGiftMissionData;
      eventsCode: number;
      user: IDailyGiftMissionData;
    }
  > => {
        let url = `/rest/o/w/live/midyear/dailyGift?anchorId=${anchorId ?? 0}`;
        if (shareBucket){
            url += `&shareBucket=${shareBucket}`;
        }
        return request.get(
            url
        );
    }
);

// 我的奖励接口
export const getMyRewards = (): Promise<AwardRes> => {
    return request.get('/rest/o/w/live/midyear/myRewards');
};

export const openAllGiftPack = (id: number): Promise<GiftPackRes> => {
    return request.get(`/rest/o/w/live/midyear/openAllGiftPack?giftId=${id}`);
};

export const rankScoreDetail = (): Promise<ScoreDetailRes> => {
    return request.get('/rest/o/w/live/midyear/rankScoreDetail');
};

// 弹窗接口
export const getPopupDetail = (
    params: PopupDetailReq
): Promise<PopupDetailRes> => {
    return request.get('/rest/o/w/live/midyear/popupDetail', { params });
};

// 过滤空奖励弹窗
export const filterEmptyRewardPop = (arr:any[]) => {
    return arr.filter(item => {
        if (item.type === 'REWARD' && !item.data?.rewards?.length){
            return false;
        }
        return true;

    });
};
